import update from 'immutability-helper';
import {
  API_LEADERBOARD_FETCH,
  API_LEADERBOARD_SUCCESS,
  API_LEADERBOARD_ERROR,
} from '../actions/types';
import {createReducer} from '../utils';
import {
  LIST_PAGE_SIZE,
} from '../configs/constants';

const initialState = {
  isLeadersListFetching: false,
  isLeadersListFetchingError: {},
  list: [],
  page: 1,
  hasMore: true,
  currentPlayer: {},
};

const leaderReducer = createReducer(initialState, {
  [API_LEADERBOARD_FETCH]: (state, payload) => {
    const {page} = payload;
    return update(state, {
      isLeadersListFetching: {$set: true},
      page: {$set: page},
    });
  },
  [API_LEADERBOARD_ERROR]: (state, payload) => {
    const {error} = payload;
    return (
      update(state, {
        isLeadersListFetchingError: {error: {$set: error}},
      })
    );
  },
  [API_LEADERBOARD_SUCCESS]: (state, payload) => {
    const {page} = state;
    const {response: {list: loadedList, count, currentPlayer}} = payload;
    const hasMore = (LIST_PAGE_SIZE * page) < count;
    const setter = (page === 1) ? '$set' : '$push';

    return update(state, {
      isLeadersListFetching: {$set: false},
      list: {[setter]: loadedList},
      hasMore: {$set: hasMore},
      page: {$set: page + 1},
      currentPlayer: {$set: currentPlayer},
    });
  },
});

export default leaderReducer;
